module.exports = __webpack_public_path__ + "img/tabs1.2b5949db.png";